import { Pipe, PipeTransform } from '@angular/core';
import { SheetActionAlertService } from '../services/sheet-action-alert.service';
import { ActionAlertTestCondition } from '../types/aggregate-graph.types';

@Pipe({
	name: 'actionAlertTemplateLabel',
	standalone: true
})
export class ActionAlertTemplateLabelPipe implements PipeTransform {

	constructor(private sheetActionAlertService: SheetActionAlertService) { }

	transform(actionControlLabel: string, alertCondition: ActionAlertTestCondition): string {
		return `Alert if '${actionControlLabel}' ${this.sheetActionAlertService.getSign(alertCondition)}`;
	}
}
